import axios from "axios";
let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "";
export default {
  state: {
   //userDetails: [],
  },
  getters: {
    //getUserDetails: (state) => state.userDetails,
  },
  actions: {
      uploadZonalMedia({}, payload) {
       return new Promise(async (resolve, reject) => {
        try {
          let urlResponse = await axios.post(`${BASE_URL}/events/zonals/upload/signedURL`, {name:payload.name});
          if (urlResponse.data.url) {
            await axios.put(urlResponse.data.url, payload, { headers: { 'Content-Type': payload.type } });
            let s3url=urlResponse.data.url.substr(0,urlResponse.data.url.indexOf("?Content-Type="));
            resolve(s3url);
          } else {
            throw('signed url api failed!');
          }
        } catch(err) {
          // let reseee=`https://avishkaar-assets.s3.amazonaws.com/blogs/1_A6kkoOVJVpXPWewg8axc5w.png?Content-Type=application%2Foctet-stream&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=utkarsh.kushwaha%40buildingblocks.in%2F20240222%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20240222T084029Z&X-Amz-Expires=60&X-Amz-Signature=87bd1247209c5764dac17fc52f393029035f502382d1258b8439bea9a8d8839c&X-Amz-SignedHeaders=host`;
          // reseee=reseee.substr(0,reseee.indexOf("?Content-Type="));
          // resolve(reseee);
          reject(err);
        }
      });
    }, 
    getIrcTeamsForScoring({}, team_level){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/admin/scorePanel/99/${team_level}`).then((response) => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    processFinalResults({}, payload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/events/finalResult`, payload).then((response) => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getLeagueScoreByteamid({}, team_id){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/admin/league/points/${team_id}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    uploadOmrSheet({}, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          let urlResponse = await axios.post(`${BASE_URL}/events/omr/upload/signedURL`, { name: payload.name });
          if (!urlResponse.data.url) throw('signed url api failed!');
          await axios.put(urlResponse.data.url, payload, { headers: { 'Content-Type': payload.type } });
          resolve(urlResponse.data.url.split('?')[0]);
        } catch(err) {
          reject(err);
        }
      });
    },
    saveOmrSheet({}, payload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/events/admin/omr/sheet`, payload).then((response) => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response && error.response.data ? error.response.data : error)
        })
      })
    },
    deleteOmrSheet({}, payload){
      return new Promise((resolve,reject) => {
        axios.delete(`${BASE_URL}/events/admin/omr/sheet/${payload.team_id}/${payload.event_id}`).then(() => {
          resolve("success")
        }).catch(error => {
          reject(error.response && error.response.data ? error.response.data : error)
        })
      })
    },
    // Teams to print arena sheets for, grouped by level and zone
    getOmrSheetBatch({}, payload){
      const q = []
      if (payload.level) q.push(`level=${encodeURIComponent(payload.level)}`)
      if (payload.zone_id) q.push(`zone_id=${encodeURIComponent(payload.zone_id)}`)
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/admin/omr/sheet-batch/${payload.event_id}${q.length ? '?' + q.join('&') : ''}`).then((response) => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response && error.response.data ? error.response.data : error)
        })
      })
    },
    getOmrScanContext({}, pass_code){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/admin/omr/context/${encodeURIComponent(pass_code)}`).then((response) => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response && error.response.data ? error.response.data : error)
        })
      })
    },
    getProjectByteamid({}, team_id){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/getEventLikesByTeam/${team_id}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getZonalScoreByteamid({}, payload){
      console.log(payload)
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/admin/zonal/points/${payload.round_id}/${payload.team_id}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getFinalScoreByteamid({}, payload){
      console.log(payload)
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/admin/finals/points/${payload.round_id}/${payload.team_id}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    addZonalScore({}, scorePayload){
      return new Promise((resolve,reject) => {
        console.log(scorePayload)
        axios.post(`${BASE_URL}/events/admin/zonal_score`,scorePayload).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    finalAmGl_score({}, scorePayload){
      return new Promise((resolve,reject) => {
        console.log(scorePayload)
        axios.post(`${BASE_URL}/events/admin/finalAmGl_score`,scorePayload).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    addLeagueScore({}, scorePayload){
      return new Promise((resolve,reject) => {
        console.log(scorePayload)
        axios.post(`${BASE_URL}/events/admin/league_score`,scorePayload).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    addEventTask({}, payload){
      return new Promise((resolve,reject) => {
        console.log(payload)
        axios.post(`${BASE_URL}/events/task`,payload).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    judgeEntry({}, payload){
      return new Promise((resolve,reject) => {
        console.log(payload)
        axios.post(`${BASE_URL}/events/judgeEntry`,payload).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    getJudgesNumber({}, payload){
      // console.log(payload)
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/getJudgesNumber/${payload}/`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    isJudgesFound({}){
      // console.log(payload)
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/isJudgesFound`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getTask({}){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/task`).then(response => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    getAllEvents({}){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/getAllEvents`).then(response => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    addEvent({}, payload){
      return new Promise((resolve,reject) => {
        console.log(payload)
        axios.post(`${BASE_URL}/events/adminPanel/create`,payload).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    addPartnerEvent({}, payload){
      return new Promise((resolve,reject) => {
        console.log(payload)
        axios.post(`${BASE_URL}/events/adminPanel/partner/eventCreate`,payload).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    getPartnerEvent({}, event_code){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/adminPanel/partner/eventDetails/${event_code}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    editPartnerEvent({}, payload){
      return new Promise((resolve,reject) => {
        console.log(payload)
        axios.post(`${BASE_URL}/events/adminPanel/partner/eventEdit`,payload).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    approvePartnerEvent({}, payload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/events/adminPanel/partner/eventApprove`,payload).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    editEvent({}, payload){
      return new Promise((resolve,reject) => {
        console.log(payload)
        axios.post(`${BASE_URL}/events/adminPanel/edit`,payload).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    getZonalEventTeam({}, payload){
      return new Promise((resolve,reject) => {
        console.log(payload)
        axios.post(`${BASE_URL}/events/zone/getTeam`,payload).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    checkEventCode({}, event_code){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/checkEventCode/${event_code}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getEventByCode({}, event_code){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/details/${event_code}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getTaskById({}, task_id){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/task/${task_id}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    editEventTask({}, payload){
      return new Promise((resolve,reject) => {
        console.log(payload)
        axios.put(`${BASE_URL}/events/task`,payload).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    scoreEventZonal({}, payload){
      return new Promise((resolve,reject) => {
        console.log(payload)
        axios.put(`${BASE_URL}/events/updatZonalScore`,payload).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    qualifyEventZonal({}, payload){
      return new Promise((resolve,reject) => {
        console.log(payload)
        axios.put(`${BASE_URL}/events/qualifyTeamZone`,payload).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    qualifyEvent({}, payload){
      return new Promise((resolve,reject) => {
        console.log(payload)
        axios.put(`${BASE_URL}/events/qualifyTeam`,payload).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    markTeamAttendance({}, payload){
      return new Promise((resolve,reject) => {
        axios.put(`${BASE_URL}/events/admin/markTeamAttendance`,payload).then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    getTeamAttendance({}, {eventId, stage, zoneId}){
      return new Promise((resolve,reject) => {
        const params = new URLSearchParams();
        if (stage) params.append('stage', stage);
        if (zoneId) params.append('zone_id', zoneId);
        const queryString = params.toString();
        axios.get(`${BASE_URL}/events/admin/getTeamAttendance/${eventId}${queryString ? `?${queryString}` : ''}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    publishEventZonal({}, payload){
      return new Promise((resolve,reject) => {
        console.log(payload)
        axios.post(`${BASE_URL}/events/zonePublishResult`,payload).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    updateEventActions({}, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          let urlResponse = await axios.put(`${BASE_URL}/events/updateActions`, payload);
          if (urlResponse.status="success") {
            resolve("updated successfully!");
          } else {
            throw('updateActions api failed!');
          }
        } catch(err) {
          reject(err);
        }
      });
    },
    getTeamDetails({}, pass_code){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/admin/getTeamByPassCode/${pass_code}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    updateMemberName({}, payload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/events/myComp/updateMemberName`, payload).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    removeMember({}, payload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/events/admin/removeMember`, payload).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    editEventTeam({}, payload){
      return new Promise((resolve,reject) => {
        console.log(payload)
        axios.post(`${BASE_URL}/events/admin/editTeam`,payload).then(response => {
          console.log(response.data)
          if(response.data.status=='success')
            resolve("success")
          else reject('api error')
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    updateTeam({}, payload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/events/regDesk/updateTeam`,payload).then(response => {
          console.log(response.data)
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    adminTeamInvite({}, payload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/events/admin/teamInvite`,payload).then(response => {
          console.log(response.data)
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    checkUsername({}, username){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/users/check/username/${username}`).then(response => {
          console.log(response.data)
          resolve(response.data)
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    createTempProfile({}, payload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/users/eventAdmin/create/profile`, payload).then(response => {
          console.log(response.data)
          resolve(response.data)
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    markTeamRegistered({}, payload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/events/admin/registrar`,payload).then(response => {
          console.log(response.data)
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    checkRegistrationStatus({}, { event_id, stage, context, team_id, zone_id }){
      return new Promise((resolve,reject) => {
        const url = `${BASE_URL}/events/admin/getRegistrarData/${event_id}/${stage}/${context}/${team_id}${zone_id ? `/${zone_id}` : ''}`;
        console.log('Checking registration status with URL:', url);
        
        axios.get(url).then(response => {
          console.log('Registration check response:', response.data)
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getAllTeam({}, event_id){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/admin/getAllTeams/${event_id}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getAllQualifiedPaidTeams({}, event_id){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/admin/getAllQualifiedPaidTeams/${event_id}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getResults({}, event_id){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/getResults/${event_id}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getEventLikes({}, event_id){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/getEventLikes/${event_id}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getEventMaxLikesByTeamLevel({}, payload){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/getEventMaxLikesByTeamLevel/${payload.level}/${payload.event_id}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    addZonal({}, payload){
      return new Promise((resolve,reject) => {
        console.log(payload)
        axios.post(`${BASE_URL}/events/zonals/create`,payload).then(response => {
          console.log(response.data)
          if(response.data.status=='success')
            resolve("success")
          else reject('api error')
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    getAllLiveEvents({}){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/getAllLiveEvents`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    upcomingZonals({}){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/getZonalsList/current`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getZonalById({},zone_id){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/zonals/${zone_id}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    updateZonal({}, payload){
      return new Promise((resolve,reject) => {
        console.log(payload)
        axios.put(`${BASE_URL}/events/updateZonals/${payload.zoneId}`,payload.zonalData).then(response => {
          console.log(response.data)
          if(response.data.status=='success')
            resolve("success")
          else reject('api error')
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    deleteZonal({}, payload){
      return new Promise((resolve,reject) => {
        console.log(payload)
        axios.delete(`${BASE_URL}/events/deleteZonals/${payload}`).then(response => {
          console.log(response.data)
          if(response.data.status=='success')
            resolve("success")
          else reject('api error')
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    getEventStatistics({}, eventId){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/statistics/${eventId}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    changeTeamZone({}, payload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/events/zoneChange`, payload).then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    getZoneMatches({}, {eventId, zoneId}){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/zone-matches/${eventId}/${zoneId}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    finalizeZoneMatches({}, {eventId, zoneId, matches}){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/events/zone-matches/finalize`, {
          event_id: eventId, zone_id: zoneId, matches: matches
        }).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    setZoneStandby({}, {id, isStandby}){
      return new Promise((resolve,reject) => {
        axios.put(`${BASE_URL}/events/zone-standby`, { id: id, is_standby: isStandby ? 1 : 0 })
          .then((response) => {
            resolve(response.data)
          }).catch(error => {
            reject(error.response ? error.response.data : error)
          })
      })
    },
    getZonalsByEvent({}, eventId){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/zonals/event/${eventId}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getEventStatsDetails({}, eventId){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/stats/details/${eventId}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getEventStatsDetailsWithFilter({}, {eventId, teamLevel, stage, zoneId, limit, offset}){
      return new Promise((resolve,reject) => {
        let url;
        if (zoneId && zoneId !== '' && zoneId !== 'all') {
          url = `${BASE_URL}/events/stats/details/${eventId}/${teamLevel}/${stage}/${zoneId}`;
        } else {
          url = `${BASE_URL}/events/stats/details/${eventId}/${teamLevel}/${stage}`;
        }
        if (limit != null) {
          url += `?limit=${limit}&offset=${offset || 0}`;
        }
        axios.get(url).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getEventStatsDetailsAdvanced({}, {eventId, teamLevel, zoneId, stage, context, verificationState}){
      return new Promise((resolve,reject) => {
        const params = new URLSearchParams();
        if (teamLevel && teamLevel !== 'all') params.append('team_level', teamLevel);
        if (zoneId && zoneId !== 'all') params.append('zone_id', zoneId);
        if (stage && stage !== 'all') params.append('stage', stage);
        if (context && context !== 'all') params.append('context', context);
        if (verificationState && verificationState !== 'all') params.append('verification_state', verificationState);

        const queryString = params.toString();
        const url = `${BASE_URL}/events/stats/track/advanced/${eventId}${queryString ? `?${queryString}` : ''}`;

        axios.get(url).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    assignSerialNumbers({}, {eventId, stage, zoneId}){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/events/assign-serial-numbers`, {
          event_id: eventId, stage: stage, zone_id: zoneId
        }).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    lockSerialNumbers({}, {eventId, stage, zoneId}){
      return new Promise((resolve,reject) => {
        axios.put(`${BASE_URL}/events/lock-serial-numbers`, {
          event_id: eventId, stage: stage, zone_id: zoneId
        }).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    getSerialState({}, {eventId, stage, zoneId}){
      return new Promise((resolve,reject) => {
        const params = new URLSearchParams();
        if (stage) params.append('stage', stage);
        if (zoneId) params.append('zone_id', zoneId);
        const queryString = params.toString();
        axios.get(`${BASE_URL}/events/serial-state/${eventId}${queryString ? `?${queryString}` : ''}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    getFinalsStats({}, {eventId, context}){
      return new Promise((resolve,reject) => {
        const url = `${BASE_URL}/events/stats/finals/${eventId}/${context}`;
        axios.get(url).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    sendOtpMessage({}, payload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/externals/message/otp`, payload).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    verifyOtpCode({}, payload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/auth/login/otp`, payload).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    createAdminTeam({}, payload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/events/admin/createTeam`, payload).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getAdminBulkTeams({}, payload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/events/admin/bulk/team`, payload).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getAdminIndividualTeam({}, payload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/events/admin/individual/team`, payload).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    fetchArenaCount({}){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/getArenaCount`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    setArenaSlot({}, payload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/events/admin/setArenaSlot`, payload).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getTeamByPassCode({}, pass_code){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/events/admin/getTeamByPassCode/${pass_code}`).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    markCashPayment({}, payload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/events/admin/markCashPayment`, payload).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
  },
  mutations: {
    //setUserDetails: (state, userData) => (state.userDetails = userData),
  },
};
